import { render, staticRenderFns } from "./dialog-box-model.vue?vue&type=template&id=6d050368&"
import script from "./dialog-box-model.vue?vue&type=script&lang=js&"
export * from "./dialog-box-model.vue?vue&type=script&lang=js&"
import style0 from "./dialog-box-model.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "dialog-box-model.vue"
export default component.exports